import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import {
  getTeamLogoFilenameCandidates,
  getTeamLogoPath,
  isTigersTeam,
} from '../utils/teamLogo';

interface TeamLogoProps {
  team: string;
  width?: string;
  height?: string;
}

const PlaceholderLogo = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || '60px'};
  height: ${props => props.height || '60px'};
  background-color: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--gray);
`;

const StyledImage = styled.img<{ width?: string; height?: string }>`
  width: ${props => props.width || '60px'};
  height: ${props => props.height || '60px'};
  object-fit: contain;
`;

const TeamLogo: React.FC<TeamLogoProps> = ({ team, width, height }) => {
  const candidates = getTeamLogoFilenameCandidates(team);
  const [candidateIndex, setCandidateIndex] = useState(0);
  const [showPlaceholder, setShowPlaceholder] = useState(false);

  useEffect(() => {
    setCandidateIndex(0);
    setShowPlaceholder(false);
  }, [team]);

  if (isTigersTeam(team)) {
    return <Logo width={width} height={height} />;
  }

  const logoPath = getTeamLogoPath(team, candidates[candidateIndex]);

  if (!showPlaceholder) {
    return (
      <StyledImage
        src={logoPath}
        alt={`${team} Logo`}
        width={width}
        height={height}
        onError={() => {
          if (candidateIndex < candidates.length - 1) {
            setCandidateIndex((index) => index + 1);
            return;
          }
          setShowPlaceholder(true);
        }}
      />
    );
  }

  return (
    <PlaceholderLogo width={width} height={height}>
      {team.charAt(0)}
    </PlaceholderLogo>
  );
};

export default TeamLogo;
